import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "p-fluid p-formgrid p-grid" }
const _hoisted_2 = { class: "p-field p-mt-1 p-col-6" }
const _hoisted_3 = { class: "p-float-label" }
const _hoisted_4 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_5 = { class: "p-field p-mt-1 p-col-6" }
const _hoisted_6 = { class: "p-float-label" }
const _hoisted_7 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_8 = { class: "p-field p-mt-1 p-col-12" }
const _hoisted_9 = { class: "p-float-label" }
const _hoisted_10 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_11 = {
  key: 0,
  class: "p-field p-mt-1 p-col-6"
}
const _hoisted_12 = { class: "p-float-label" }
const _hoisted_13 = {
  for: "scope",
  class: "kn-material-input-label"
}
const _hoisted_14 = {
  key: 1,
  class: "p-field p-mt-1 p-col-6"
}
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = {
  key: 0,
  for: "category",
  class: "kn-material-input-label"
}
const _hoisted_17 = {
  key: 1,
  for: "category",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    content: _withCtx(() => [
      _createVNode("form", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("span", _hoisted_3, [
            _createVNode(_component_InputText, {
              id: "label",
              class: ["kn-material-input", { 'p-invalid': _ctx.v$.dataset.label.$invalid && _ctx.v$.dataset.label.$dirty }],
              type: "text",
              maxLength: "50",
              modelValue: _ctx.v$.dataset.label.$model,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.dataset.label.$model = $event)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.dataset.label.$touch())),
              onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched'))),
              "data-test": "label-input"
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.dataset.label,
            additionalTranslateParams: { fieldName: _ctx.$t('common.label') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_5, [
          _createVNode("span", _hoisted_6, [
            _createVNode(_component_InputText, {
              id: "name",
              class: ["kn-material-input", { 'p-invalid': _ctx.v$.dataset.name.$invalid && _ctx.v$.dataset.name.$dirty }],
              type: "text",
              maxLength: "50",
              modelValue: _ctx.v$.dataset.name.$model,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.dataset.name.$model = $event)),
              onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.dataset.name.$touch())),
              onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched'))),
              "data-test": "name-input"
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_7, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.dataset.name,
            additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("span", _hoisted_9, [
            _createVNode(_component_InputText, {
              id: "description",
              class: ["kn-material-input", { 'p-invalid': _ctx.v$.dataset.description.$invalid && _ctx.v$.dataset.description.$dirty }],
              type: "text",
              maxLength: "150",
              modelValue: _ctx.v$.dataset.description.$model,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.dataset.description.$model = $event)),
              onBlur: _cache[8] || (_cache[8] = ($event: any) => (_ctx.v$.dataset.description.$touch())),
              onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('touched'))),
              "data-test": "description-input"
            }, null, 8, ["modelValue", "class"]),
            _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('common.description')), 1)
          ]),
          _createVNode(_component_KnValidationMessages, {
            class: "p-mt-1",
            vComp: _ctx.v$.dataset.description,
            additionalTranslateParams: { fieldName: _ctx.$t('common.description') }
          }, null, 8, ["vComp", "additionalTranslateParams"])
        ]),
        (_ctx.qbeAdvancedSaving)
          ? (_openBlock(), _createBlock("div", _hoisted_11, [
              _createVNode("span", _hoisted_12, [
                _createVNode(_component_Dropdown, {
                  id: "scope",
                  class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.scopeCd.$invalid && _ctx.v$.dataset.scopeCd.$dirty
                            }],
                  options: _ctx.scopeTypes,
                  optionLabel: "VALUE_CD",
                  optionValue: "VALUE_CD",
                  modelValue: _ctx.v$.dataset.scopeCd.$model,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.dataset.scopeCd.$model = $event)),
                  onBeforeShow: _cache[11] || (_cache[11] = ($event: any) => (_ctx.v$.dataset.scopeCd.$touch())),
                  onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.updateIdFromCd(this.scopeTypes, 'scopeId', $event.value), _ctx.$emit('touched'))),
                  "data-test": "scope-input"
                }, null, 8, ["options", "modelValue", "class"]),
                _createVNode("label", _hoisted_13, _toDisplayString(_ctx.$t('managers.datasetManagement.scope')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.dataset.scopeCd,
                additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.datasetManagement.scope')
                        }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.qbeAdvancedSaving)
          ? (_openBlock(), _createBlock("div", _hoisted_14, [
              _createVNode("span", _hoisted_15, [
                _createVNode(_component_Dropdown, {
                  id: "category",
                  class: ["kn-material-input", {
                                'p-invalid': _ctx.v$.dataset.catTypeVn.$invalid && _ctx.v$.dataset.catTypeVn.$dirty
                            }],
                  options: _ctx.categoryTypes,
                  optionLabel: "VALUE_CD",
                  optionValue: "VALUE_CD",
                  modelValue: _ctx.v$.dataset.catTypeVn.$model,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.v$.dataset.catTypeVn.$model = $event)),
                  onBeforeShow: _cache[14] || (_cache[14] = ($event: any) => (_ctx.v$.dataset.catTypeVn.$touch())),
                  onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.updateIdFromCd(this.categoryTypes, 'catTypeId', $event.value), _ctx.$emit('touched'))),
                  "data-test": "category-input"
                }, null, 8, ["options", "modelValue", "class"]),
                (this.dataset.scopeCd == 'USER')
                  ? (_openBlock(), _createBlock("label", _hoisted_16, _toDisplayString(_ctx.$t('common.category')), 1))
                  : (_openBlock(), _createBlock("label", _hoisted_17, _toDisplayString(_ctx.$t('common.category')) + " * ", 1))
              ]),
              _createVNode(_component_KnValidationMessages, {
                vComp: _ctx.v$.dataset.catTypeVn,
                additionalTranslateParams: {
                            fieldName: _ctx.$t('managers.datasetManagement.scope')
                        }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}